import "./index.css";
import Home from "./pages/Home";
import Work from "./pages/Work";
import Service from "./pages/Service";
import About from "./pages/About";
import Testimonial from "./pages/Testimonial";
import Contact from "./pages/Contract";
import { Route, Routes } from "react-router-dom";
import ProductDetail from "./pages/ProductDetail";

function App() {
  return (
    <div className="App min-h-screen">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/service" element={<Service />} />
        <Route path="/about" element={<About />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product/:id" element={<ProductDetail />} />
      </Routes>
    </div>
  );
}

export default App;
